import React from 'react'
import Select from 'react-select'

const BRAND_TINT = 'rgba(95, 152, 186, 0.1)';
const BORDER = '#e3e3e3';
const TEXT_STRONG = '#3d3d3d';

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    minHeight: '36px',
    // No focus ring: the filter strip is small and a blue halo reads as noise.
    borderColor: state.isFocused ? '#c4c4c4' : BORDER,
    boxShadow: 'none',
    '&:hover': {
      borderColor: '#d0d0d0',
    },
    borderRadius: "6px",
    cursor: 'pointer',
    transition: 'border-color 0.15s ease, box-shadow 0.15s ease',
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: '8px',
    border: `1px solid ${BORDER}`,
    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)',
    overflow: 'hidden',
    zIndex: 20,
  }),
  menuList: (provided) => ({
    ...provided,
    padding: '4px',
  }),
  option: (provided, state) => ({
    ...provided,
    borderRadius: '4px',
    padding: '6px 8px',
    backgroundColor: state.isSelected || state.isFocused ? BRAND_TINT : 'transparent',
    color: TEXT_STRONG,
    fontWeight: state.isSelected ? 700 : 500,
    cursor: 'pointer',
    ':active': {
      backgroundColor: BRAND_TINT,
    },
  }),
  placeholder: (provided) => ({
    ...provided,
    color: '#808080',
  }),
  singleValue: (provided) => ({
    ...provided,
    margin: 0,
    color: TEXT_STRONG,
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    backgroundColor: BORDER,
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: '0 0 0 8px',
  }),
  input: (provided) => ({
    ...provided,
    margin: 0,
    padding: 0,
  }),
  clearIndicator: (provided) => ({
    ...provided,
    padding: '0 2px 0 0',
    color: '#999',
    ':hover': { color: TEXT_STRONG },
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    padding: '2px 4px',
    color: '#999',
    ':hover': { color: TEXT_STRONG },
  }),
};

const Dropdown = ({ style, options, value, onChange, placeholder = "Select team...", isSearchable = true }) => {
  const formatOptionLabel = ({ value, label, team_id }) => (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {team_id && (
        <img
          style={{ verticalAlign: "middle", padding: "4px" }}
          src={`https://omo.akamai.opta.net/image.php?secure=true&h=omo.akamai.opta.net&sport=football&entity=team&description=badges&dimensions=150&id=${team_id}`}
          height={17}
          width={17}
          alt="team-logo"
        />
      )}
      <span>{label}</span>
    </div>
  );

  return (
    <div className="font-number-capital" style={style}>
      <Select
        options={options}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        isClearable
        formatOptionLabel={formatOptionLabel}
        styles={customStyles}
        isSearchable={isSearchable}
      />
    </div>
  );
};

export default Dropdown;